
import Vue from 'vue'
import ContestDetails from '@/components/contest/ContestDetails.vue'
import { Contest } from '@/model/Contest'
import {UserV2} from '@/model/User'

export default Vue.extend({
  name: 'Contest',
  components: {
    ContestDetails,
  },
  props: {
    slug: {
      type: String,
    },
  },
  mounted() {
    this.fetchContest()
  },
  data: () => ({
    contest: { id: null } as Contest,
    user: { id: '' } as UserV2,
  }),
  methods: {
    fetchContest: function () {
      this.$api
        .get('/contests/slug/' + this.slug)
        .then((response) => (this.contest = response.data))

      if (this.$store.state.authentication.signedIn) {
        this.$api
          .get(
            '/users/nickname/' + this.$store.state.authentication.user.nickname
          )
          .then((response) => (this.user = response.data))
      }
    },
    participationCancelled: function () {
      this.contest.userApplicationStatus = ''
      if (this.contest.applicationsCount - 1 >= 0) {
        this.contest.applicationsCount--
      }
    },
  },
})
